import { TOGGLE_Special_FILTER_MENU } from './constants';

export function toggleSpecialFilterMenu(value) {
  return {
    type: TOGGLE_Special_FILTER_MENU,
    value,
  };
}
